import {createSelector} from 'reselect';

export const locationsSelector = createSelector(
  (state) => state?.geo,
  (geo = {}) => geo?.locations || []
);

export const userLocationsSelector = createSelector(
  (state) => state?.user,
  (user = {}) => user?.location
);

export const locationDialogNeedOpenSelector = createSelector(
  (state) => state?.user,
  (user = {}) => user?.locationDialog === 'open'
);
